import React from "react";

import { useSelector } from "react-redux";

import { Button } from "components/Form";
import IdConnectedList from "components/IdConnectedList";
import { Row } from "components/Layout";
import WaitForSync from "components/LoadingSpinner/WaitForSync";
import MessageBox from "components/MessageBox";

import { ApiModel } from "constants/loading";

import { openImportAuctionsPlusCSV } from "lib/navigation";

import { getCurrentSale, selectAlphabeticalBuyerIds } from "selectors";

import { BuyerCard } from "./BuyerCard";

function EmptyBuyers() {
  return <MessageBox>No Lots sold yet.</MessageBox>;
}

export const BuyersComponent = () => {
  const sale = useSelector(getCurrentSale);

  const buyerIds = useSelector(selectAlphabeticalBuyerIds);
  return (
    <div>
      <Row padding={1}>
        <Button onClick={() => openImportAuctionsPlusCSV(sale)}>
          Import AuctionsPlus Results
        </Button>
      </Row>
      <IdConnectedList
        component={BuyerCard}
        orderedIds={buyerIds}
        emptyComponent={EmptyBuyers}
      />
    </div>
  );
};

// Wait For Sync Wrapper
export const Buyers = () => {
  return (
    <WaitForSync
      requiredData={[
        ApiModel.SALE_LOTS,
        ApiModel.CONSIGNMENTS,
        ApiModel.BUSINESSES,
      ]}
    >
      <BuyersComponent />
    </WaitForSync>
  );
};
